export const validator = {
  validate: (formData) => {
    const errors = {};
    const warnings = {};

    const {
      contractorDetails = {},
      siteDetails = {},
      chpSpecification = {},
      gasAndCombustion = {},
      declarations = {}
    } = formData;

    if (!contractorDetails.companyName?.trim()) {
      errors['contractorDetails.companyName'] = 'Company name is required';
    }
    if (!contractorDetails.engineerName?.trim()) {
      errors['contractorDetails.engineerName'] = 'Lead engineer name is required';
    }
    if (!contractorDetails.gasSafeLicence?.trim()) {
      errors['contractorDetails.gasSafeLicence'] = 'Gas Safe / Competency ID is required';
    }
    if (!siteDetails.siteName?.trim()) {
      errors['siteDetails.siteName'] = 'Site name is required';
    }
    if (!chpSpecification.manufacturer?.trim()) {
      errors['chpSpecification.manufacturer'] = 'CHP manufacturer is required';
    }
    if (!chpSpecification.model?.trim()) {
      errors['chpSpecification.model'] = 'CHP model is required';
    }

    // CO ppm emission threshold check
    const coPpm = Number(gasAndCombustion.flueCoPpm) || 0;
    if (coPpm > 250) {
      warnings['gasAndCombustion.flueCoPpm'] = `High CO level recorded (${coPpm} ppm). Check air-fuel ratio / lambda sensor calibration.`;
    }

    if (!declarations.engineerSignature) {
      errors['declarations.engineerSignature'] = 'Engineer signature is required';
    }

    return {
      isValid: Object.keys(errors).length === 0,
      errors,
      warnings
    };
  }
};

export default validator;
